import { ColumnsType } from "antd/es/table";
import { COLOR_TYPE, PropertyData, UserData } from "./CampaignReport.type";
import { Tag } from "Components";
import { PDF_URL } from "PhishingManager/service/index.constant";

export const STATUS_COLOR: Record<string, COLOR_TYPE> = {
    highest: { bg: "#CDE7CF", color: "#2E7D32" },
    high: { color: '#1976D2', bg: '#E8F1FB' },
    medium: { bg: "#FEF6E9", color: "#f9a825" },
    low: { bg: "#FBEAEA", color: "#D32F2F" },
};

export const RESULT_COLOR: Record<string, COLOR_TYPE> = {
    passed: { bg: "#CDE7CF", color: "#2E7D32" },
    failed: { bg: "#FBEAEA", color: "#D32F2F" },
};

export const INTERACTION_COLOR: COLOR_TYPE = { color: '#1976D2', bg: '#E8F1FB' };

export const GET_COLOR_BY_SCORE = (score: number) => {
    const status = score >= 97 ? "highest" : (score < 97 && score >= 94)  ? "high" : (score < 94 && score >= 90) ? "medium" : "low"
    const { bg, color } = STATUS_COLOR[status];
    return {
        bg, color,
        tag: score >= 97 ? "Excellent" : (score < 97 && score >= 94)  ? "Good" : (score < 94 && score >= 90) ? "Fair" : "Poor"
    }
}

export const TABLE_TABS = ["individual", "property"];

const renderStatusTag = (value: number, color: string, bg: string) => {
    return value ? <Tag className='status-tag' style={{ color, background: bg }}>{value}</Tag> : 
    <Tag className='status-tag' style={{ color: '#636766', background: '#eaeaeb' }}>-</Tag>
};

const renderPercentTag = (value: number) => {
    const { color, bg } = GET_COLOR_BY_SCORE(value);
    return <Tag className='status-tag' style={{ color, background: bg }}>{`${value}%`}</Tag>
};

export const INDIVIDUAL_TABLE_COLUMNS: ColumnsType<UserData> = [
    {
        title: "Name",
        dataIndex: "name",
        key: "name",
    },
    {
        title: "Email Address",
        dataIndex: "email",
        key: "email",
        responsive: ['lg', 'xl', 'xxl'],
    },
    {
        title: "Property",
        dataIndex: "propertyName",
        key: "propertyName",
    },
    {
        title: "Group",
        dataIndex: "groupName",
        key: "groupName",
    },
    {
        title: "Source",
        dataIndex: "doneBy",
        key: "doneBy",
        render: (doneBy) => doneBy || "-"
    },
    {
        title: "Result",
        dataIndex: "result",
        key: "result",
        align: "center",
        // Optional: Color code Passed vs Failed
        render: (result) => {
            const { color, bg } = RESULT_COLOR[String(result).toLowerCase()] || RESULT_COLOR.passed;
            return renderStatusTag(result, color, bg);
        }
    },
    {
        title: "Interaction",
        dataIndex: "interaction",
        key: "interaction",
        align: "center",
        render: (interaction) => {
            const { color, bg } = INTERACTION_COLOR;
            return renderStatusTag(interaction, color, bg);
        }
    },
]

export const PROPERTY_TABLE_COLUMNS: ColumnsType<PropertyData> = [
    {
        title: "Property Name",
        dataIndex: "propertyName",
        key: "propertyName",
    },
    {
        title: "Pass Rate",
        dataIndex: "passRate",
        key: "passRate",
        align: "center",
        render: (value: number) => renderPercentTag(value),
    },
    {
        title: "Open Rate",
        dataIndex: "openRate",
        key: "openRate",
        align: "center",
        render: (value: number) => renderPercentTag(value),
    },
    {
        title: "Click Rate",
        dataIndex: "clickRate",
        key: "clickRate",
        align: "center",
        render: (value: number) => renderPercentTag(value),
    },
    {
        title: "Submission Rate",
        dataIndex: "submissionRate",
        key: "submissionRate",
        align: "center",
        render: (value: number) => renderPercentTag(value),
        responsive: ['lg', 'xl', 'xxl'],
    },
    {
        title: "Emails Sent",
        dataIndex: "emailsSent",
        key: "emailsSent",
    },
    {
        title: "Opened Email",
        dataIndex: "openedEmail",
        key: "openedEmail",
        responsive: ['lg', 'xl', 'xxl'],
    },
    {
        title: "Clicked Link",
        dataIndex: "clickedLink",
        key: "clickedLink",
        responsive: ['lg', 'xl', 'xxl'],
    },
    {
        title: "Submitted Data",
        dataIndex: "submittedData",
        key: "submittedData",
        responsive: ['lg', 'xl', 'xxl'],
    },
    {
        title: "Total Users",
        dataIndex: "totalUsers",
        key: "totalUsers",
    }
];

export const INTERACTION_PDF_URL =  `${PDF_URL}/learn-more-pages/interpreting_results.pdf`;
export const AUTOMATION_PDF_URL = `${PDF_URL}/learn-more-pages/automation_detection.pdf`;